import { PERMISSION_TYPE, type PERMISSION_VALUE } from '@/permissions'
import { ROLE_TYPE } from '../permissions'

export enum PROJECT_TITLE_PERMISSION {
  CHANGE_TITLE = 'CHANGE_TITLE',
  CHANGE_LOGO = 'CHANGE_LOGO',
}

export const getProjectTitlePermissionsMatrix = (): Record<
  PROJECT_TITLE_PERMISSION,
  Record<ROLE_TYPE, PERMISSION_VALUE>
> => {
  return {
    [PROJECT_TITLE_PERMISSION.CHANGE_TITLE]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [PROJECT_TITLE_PERMISSION.CHANGE_LOGO]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.NA },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
  }
}
